import { Box, Typography, Modal, Button } from '@mui/material';

import useStyles from './styles';
import deleteLogo from '../../assets/images/delete.png';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};


const Delete = ({ open, handleClose, deleteNotification }) => {
    const classes = useStyles();

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} className={classes.notificationDeleteContainer}>
                <img
                    className={classes.logotypeIcon}
                    src={deleteLogo}
                    alt="logo"
                    width="80"
                />
                <Typography id="modal-modal-titles" className={classes.deleteModalHeading}>
                    Are you sure you want to delete this notification ?
                </Typography>

                <div className={classes.deleteButtonGroup}>
                    <Button variant='outlined' className={`${classes.notificationButton} ${classes.deleteButtonDimensions}`} onClick={handleClose}>Cancel</Button>
                    <Button variant="outlined" className={`${classes.notificationButton} ${classes.deleteButtonDimensions}`} onClick={deleteNotification}>Delete</Button>
                </div>
            </Box>
        </Modal>
    );
};

export default Delete;